/**
 * Best-effort emoji for a device name: keyword match → category → default.
 * Not stored in the DB — purely display-side heuristics.
 */

const DEFAULT_ICON = '📟';

const CATEGORY_ICONS = {
  imaging: '📷',
  monitoring: '📊',
  respiratory: '🫁',
  cardiac: '❤️',
  infusion: '💉',
  laboratory: '🔬',
  sterilization: '♨️',
  surgical: '🔪',
  anesthesia: '😷',
  neonatal: '👶',
  renal: '💧',
  environmental: '🌬️',
  diagnostic: '🩺',
  obstetric: '🤰',
  emergency: '🚨',
  transport: '♿',
  furniture: '🛏️',
  consumable: '🧴',
};

/** Longer / more specific keywords first */
const KEYWORD_ICONS = [
  { match: /defibrillator|pacemaker|holter|\becg\b|\bekg\b/i, icon: '❤️' },
  { match: /ventilator|cpap|bipap|nebulizer|spirometer|oxygen concentrator/i, icon: '🫁' },
  { match: /x-?\s*ray|ct scanner|\bmri\b|ultrasound|doppler|thermal imaging/i, icon: '📷' },
  { match: /infusion pump|syringe pump|infusion warmer|infusion stand/i, icon: '💉' },
  { match: /microscope|centrifuge|analyzer|glucometer|hematology|coagulation|immunoassay/i, icon: '🔬' },
  { match: /autoclave|steriliz/i, icon: '♨️' },
  { match: /endoscope|laparoscope|colposcope|electrosurgical|surgical (light|table)|laser system/i, icon: '🔪' },
  { match: /anesthesia/i, icon: '😷' },
  { match: /incubator|phototherapy|neonatal/i, icon: '👶' },
  { match: /dialysis|hemodialysis/i, icon: '💧' },
  { match: /dehumidifier|air purifier|hepa/i, icon: '🌬️' },
  { match: /otoscope|ophthalmoscope/i, icon: '🩺' },
  { match: /fetal|cardiotocograph|\bctg\b/i, icon: '🤰' },
  { match: /crash cart/i, icon: '🚨' },
  { match: /wheelchair|stretcher|gurney/i, icon: '♿' },
  { match: /hospital bed|mattress/i, icon: '🛏️' },
  { match: /syringe|needle|cannula|catheter|gloves|gown|\bmask\b/i, icon: '🧴' },
  { match: /monitor|oximeter|thermometer|capnography|scale/i, icon: '📊' },
];

/**
 * @param {{ name?: string, category?: string } | string | null | undefined} deviceName
 * @returns {string} emoji icon
 */
export function getDeviceNameIcon(deviceName) {
  const name = typeof deviceName === 'string'
    ? deviceName
    : (deviceName?.name || '');
  const category = typeof deviceName === 'string'
    ? ''
    : (deviceName?.category || '');

  if (name) {
    for (const { match, icon } of KEYWORD_ICONS) {
      if (match.test(name)) return icon;
    }
  }

  if (category) {
    const categoryIcon = CATEGORY_ICONS[String(category).trim().toLowerCase()];
    if (categoryIcon) return categoryIcon;
  }

  return DEFAULT_ICON;
}
